
import { slotSeeker } from '@/utils';

export default {
  functional: true,
  render() {
    return slotSeeker('app-root-slot');
  },
};
